import Header from './styled';

export default Header;
